var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "310.000000pt",
    height: "84.000000pt",
    viewBox: "0 0 310.000000 84.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,84.000000) scale(0.100000,-0.100000)",
    fill: "#129bca",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 420 l0 -420 1550 0 1550 0 0 420 0 420 -1550 0 -1550 0 0 -420z m996 273 c71 -24 157 -112 178 -183 35 -119 12 -216 -72 -300 -73 -72 -133 -95 -236 -88 -154 10 -263 116 -274 267 -2 36 1 84 7 106 24 90 97 168 188 201 53 18 150 17 209 -3z m-603 -7 c43 -17 85 -68 93 -111 7 -40 -9 -96 -36 -120 -19 -17 -19 -18 22 -55 38 -34 42 -41 46 -96 3 -50 0 -65 -20 -94 -13 -19 -43 -45 -68 -57 -40 -21 -59 -23 -192 -23 l-148 0 0 285 0 285 135 0 c92 0 146 -4 168 -14z m1027 -96 l0 -110 110 0 110 0 0 110 0 110 65 0 65 0 0 -285 0 -285 -65 0 -65 0 0 115 0 115 -110 0 -110 0 0 -115 0 -115 -65 0 -65 0 0 285 0 285 65 0 65 0 0 -110z m860 -135 c53 -132 104 -259 113 -282 l17 -43 -69 0 -69 0 -22 60 -22 60 -107 0 -107 0 -21 -57 -20 -58 -68 -3 c-61 -3 -67 -1 -61 15 4 10 55 139 113 286 l107 268 60 -3 60 -3 96 -240z m460 65 l125 -179 3 180 2 179 65 0 65 0 0 -285 0 -285 -68 0 -68 0 -124 176 -125 175 -3 -175 -2 -176 -65 0 -65 0 0 285 0 285 68 0 67 -1 125 -179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 573 c-19 -10 -48 -35 -65 -56 -27 -34 -31 -47 -31 -102 0 -55 4 -68 31 -102 17 -21 46 -46 65 -56 71 -37 175 -1 216 76 22 41 22 123 0 164 -41 77 -145 113 -216 76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 535 l0 -65 39 0 c56 0 89 15 97 44 13 54 -24 86 -102 86 l-34 0 0 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 305 l0 -65 68 0 c77 0 102 16 102 63 0 42 -42 67 -111 67 l-59 0 0 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087 447 c-15 -41 -27 -77 -27 -80 0 -4 29 -7 64 -7 l64 0 -30 80 c-17 44 -34 80 -37 80 -4 0 -19 -33 -34 -73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b973deaefab217e0f765125a5d2237c.svg";
export { ForwardRef as ReactComponent };